import { withBemMod } from '@bem-react/core';

import { cnTag } from '../Tag.cn';

import './Tag_size_s.css';

export type WithSizeSProps = {
    size?: 's';
};

export const withSizeS = withBemMod<WithSizeSProps>(cnTag(), {});
